// NAIZOR — quiz «¿Qué tipo de ojeras tienes?». Sin dependencias. Todos los textos están ya en el HTML (idiomas en Liquid).
// Flujo: 3 preguntas -> pantalla «construyendo tu fórmula» (unos segundos) -> resultado, que se queda en pantalla
// -> debajo, tarjeta opcional «envíame mi resultado por correo» (Klaviyo: suscripción + evento que dispara el correo).
(function () {
  var REVISION = '2024-10-15';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var steps = Array.prototype.slice.call(root.querySelectorAll('.nz-quiz__step'));
    var building = root.querySelector('[data-nz-building]');
    var buildLine = root.querySelector('[data-nz-building-line]');
    var buildBar = root.querySelector('[data-nz-building-bar]');
    var result = root.querySelector('[data-nz-result]');
    var progress = root.querySelector('[data-nz-progress]');
    var count = root.querySelector('[data-nz-count]');
    var bar = root.querySelector('[data-nz-bar]');
    var label = root.getAttribute('data-step-label') || 'Question [n] of 3';
    var answers = {};
    var current = 0;
    var busy = false;
    var timers = [];

    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }

    function show(i) {
      clearTimers();
      busy = false;
      current = i;
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      building.hidden = true;
      result.hidden = true;
      progress.hidden = false;
      count.textContent = label.replace('[n]', String(i + 1));
      bar.style.width = ((i + 1) / 3) * 100 + '%';
      root.querySelectorAll('.nz-quiz__opt.is-picked').forEach(function (o) { o.classList.remove('is-picked'); });
      var f = steps[i].querySelector('.nz-quiz__opt');
      if (f && root.dataset.focus) f.focus();
    }

    // Pantalla de «construyendo»: da tiempo a que se sienta el resultado y no aparece de golpe
    function build() {
      steps.forEach(function (s) { s.hidden = true; });
      progress.hidden = true;
      result.hidden = true;
      building.hidden = false;
      var lines = [buildLine.getAttribute('data-l1'), buildLine.getAttribute('data-l2'), buildLine.getAttribute('data-l3')];
      var total = reduceMotion ? 1000 : 2800;
      buildLine.textContent = lines[0];
      buildBar.style.transition = 'none';
      buildBar.style.width = '0%';
      void buildBar.offsetWidth;
      buildBar.style.transition = 'width ' + total + 'ms cubic-bezier(.4,.1,.2,1)';
      buildBar.style.width = '100%';
      if (!reduceMotion) {
        later(function () { buildLine.textContent = lines[1]; }, total * 0.36);
        later(function () { buildLine.textContent = lines[2]; }, total * 0.68);
      }
      later(showResult, total + 250);
    }

    function showResult() {
      clearTimers();
      steps.forEach(function (s) { s.hidden = true; });
      building.hidden = true;
      progress.hidden = true;
      result.hidden = false;
      var pigment = answers[1] === 'brown';
      result.querySelectorAll('[data-nz-res]').forEach(function (e) { e.hidden = e.getAttribute('data-nz-res') !== (pigment ? 'pigment' : 'other'); });
      result.querySelectorAll('[data-nz-btns]').forEach(function (e) { e.hidden = e.getAttribute('data-nz-btns') !== (pigment ? 'pigment' : 'other'); });
      result.querySelectorAll('[data-nz-extra]').forEach(function (e) {
        var k = e.getAttribute('data-nz-extra');
        e.hidden = !((k === 'puffy' && answers[2] === 'often') || (k === 'dry' && answers[3] === 'dry') || (k === 'oily' && answers[3] === 'oily'));
      });
      // Se muestra el resultado desde su principio y se queda quieto (nada cambia solo después)
      var top = result.getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      try { result.focus({ preventScroll: true }); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('nz:quiz-result', { detail: { type: pigment ? 'pigment' : 'other' } })); } catch (e) {}
    }

    root.addEventListener('click', function (ev) {
      var opt = ev.target.closest('.nz-quiz__opt');
      if (opt) {
        if (busy) return;
        busy = true;
        root.dataset.focus = '1';
        answers[current + 1] = opt.getAttribute('data-a');
        opt.classList.add('is-picked');
        // Pequeña pausa para que se vea la respuesta elegida antes de pasar a la siguiente
        later(function () { busy = false; if (current < 2) show(current + 1); else build(); }, reduceMotion ? 120 : 420);
        return;
      }
      if (ev.target.closest('[data-nz-back]')) { show(Math.max(0, current - 1)); return; }
      if (ev.target.closest('[data-nz-restart]')) {
        answers = {};
        show(0);
        var qTop = root.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: Math.max(0, qTop), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    });

    // ---- Envío del resultado por correo ----
    function visibleText(sel) {
      var el = Array.prototype.slice.call(result.querySelectorAll(sel)).filter(function (e) { return !e.hidden && !e.closest('[hidden]'); })[0];
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function resultPayload() {
      var pigment = answers[1] === 'brown';
      var btns = result.querySelector('[data-nz-btns="' + (pigment ? 'pigment' : 'other') + '"]');
      var first = btns && btns.querySelector('a');
      var base = root.getAttribute('data-base') || location.origin;
      var url = '';
      try { url = new URL(first.getAttribute('href'), base).href; } catch (e) {}
      var extras = Array.prototype.slice.call(result.querySelectorAll('[data-nz-extra]')).filter(function (e) { return !e.hidden; }).map(function (e) { return e.textContent.replace(/\s+/g, ' ').trim(); });
      return {
        ResultType: pigment ? 'pigment' : 'other',
        Language: root.getAttribute('data-lang') || 'en',
        Subject: root.getAttribute('data-mail-subject'),
        Intro: root.getAttribute('data-mail-intro'),
        ResultTitle: visibleText('.nz-quiz__rt'),
        ResultText: visibleText('.nz-quiz__rx'),
        Extras: extras.join(' '),
        ButtonLabel: first ? first.textContent.replace(/\s+/g, ' ').trim() : '',
        ButtonURL: url,
        CodeLine: root.getAttribute('data-mail-code'),
        GuaranteeLine: root.getAttribute('data-mail-guarantee'),
        SignOff: root.getAttribute('data-mail-signoff'),
        AnswerColor: answers[1] || '',
        AnswerPuffiness: answers[2] || '',
        AnswerSkin: answers[3] || ''
      };
    }
    function klaviyoPost(path, body) {
      var company = root.getAttribute('data-company');
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); });
    }
    function sendToKlaviyo(email) {
      var list = root.getAttribute('data-list');
      var props = resultPayload();
      var profile = { data: { type: 'profile', attributes: { email: email, properties: { 'Dark Circle Quiz Result': props.ResultType, Language: props.Language } } } };
      var subscribe = klaviyoPost('subscriptions', {
        data: {
          type: 'subscription',
          attributes: { custom_source: 'Dark Circle Quiz', profile: profile },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      });
      var track = klaviyoPost('events', {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Completed Dark Circle Quiz' } } },
            profile: profile,
            properties: props,
            time: new Date().toISOString()
          }
        }
      });
      return Promise.all([subscribe, track]);
    }

    var form = root.querySelector('.nz-quiz__form');
    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var btn = form.querySelector('button[type="submit"]');
        var msg = form.querySelector('[data-nz-mail-msg]');
        var email = form.querySelector('input[type="email"]').value.trim();
        if (btn) btn.disabled = true;
        msg.hidden = true;
        // 1) cliente en Shopify (casilla de marketing, como antes) 2) Klaviyo: suscripción + evento que dispara el correo con el resultado
        var data = new FormData(form);
        data.delete('nz_consent');
        fetch(form.action, { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(function () {});
        sendToKlaviyo(email)
          .then(function () {
            msg.textContent = root.getAttribute('data-msg-sent');
            msg.classList.remove('is-error');
            msg.hidden = false;
            form.querySelectorAll('.nz-quiz__field, .nz-quiz__consent, .nz-quiz__actions').forEach(function (e) { e.hidden = true; });
          })
          .catch(function () {
            msg.textContent = root.getAttribute('data-msg-error');
            msg.classList.add('is-error');
            msg.hidden = false;
            if (btn) btn.disabled = false;
          });
      });
    }
    show(0);
  }
  function boot() { document.querySelectorAll('[data-nz-quiz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
